import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Website} from "../../website";
import {Product} from "../../product";
import {IActivity} from "../../../../activities/activity";
import {Observable} from "rxjs";
import {DbStoreState} from "../../../../store/reducers/index";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../../store';

@Component({
    selector: 'db-product-item-schedule',
    templateUrl: './product-item-schedule.component.html',
    styleUrls: ['./product-item-schedule.component.scss'],
    standalone: false
})
export class ProductItemScheduleComponent implements OnInit {


  @Input() website: Website;
  @Input() product: Product;

  @ViewChild('logo') logoRef: ElementRef;

  @Output() toggled: EventEmitter<void>;
  public ongoingActivity$: Observable<IActivity>;


  constructor(
    private _store: Store<DbStoreState>,
  ) {
    this.toggled = new EventEmitter<void>();
  }


  ngOnInit() {
    this.ongoingActivity$ = this._store.select(fromStore.getProductOngoingActivity(this.website.id, this.product.slug));
  }

  public onItemToggled(): void {
    this.toggled.emit();
  }

  public stopEvent($event): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
}
